import { ProfilesOptionsParams } from "PFCore/services/profile";

export const profilesKeys = {
  all: (...args) => ["profiles", ...args],
  options: (params: ProfilesOptionsParams) => [...profilesKeys.all(), "options", params]
};
